<!--  -->
<template>
    <div class="Pagination">
        <nav>
            <ul>
                <li class="totalbox">
                    <span class="totalRow">共 {{ totalRow }} 条</span>
                    <span>{{ currentPage }}/{{ totalPages }}页</span>
                </li>
                <li @click="prepage()" :disabled="currentPage === 1" v-if="currentPage > 1">
                    上一页
                </li>
                <li :class="currentPage == index ? 'active' : ''" v-for="index in pages" @click="curpage(index)">
                    {{ index }}
                </li>
                <li @click="nexpage()" :disabled="currentPage === totalPages"
                    v-if="totalPages > 1 && currentPage < totalPages">
                    下一页
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
import localStorageApi from '@/utils/localStorageUtils'
export default {
    name: "Pagination",
    props: {
        // 总页数
        totalPages: {
            type: Number,
            required: true,
        },
        // 总行数
        totalRow: {
            type: Number,
            required: true,
        },
        // 当前页数
        currentPage: {
            type: Number,
        }
    },
    data() {
        return {

        };
    },
    //计算属性
    computed: {
        pages() {
            let total = this.totalPages;
            let p = this.currentPage;
            if (total < 10) return total//小于10页全部返回
            if (p < 5) {
                //当前页小于5的时候
                return [1, 2, 3, 4, 5, "...", total]
            } else if (p >= total - 5) {
                // 当前页大于等于总页数-5  显示最后六页
                return ["...", total - 6, total - 5, total - 4, total - 3, total - 2, total - 1, total]
            } else {
                // 页码在中间位置
                return ["...", p - 2, p - 1, p, p + 1, p + 2, "...", total]
            }
        }
    },

    methods: {
        getPages(page) {
            // 修改父组件当前页的值
            this.$emit('update:currentPage', page)
        },
        curpage(index) {
            // console.log('当前页', index)
            if (index == "...") return
            this.getPages(index)
            if (this.$route.name !== 'My') {
                window.scrollTo(0, 0)
            }

        },
        prepage() {
            // console.log('上一页')
            if (this.currentPage > 1) {
                this.$emit('update:currentPage', this.currentPage - 1)
                if (this.$route.name !== 'My') {
                    window.scrollTo(0, 0)
                }
            }
        },
        nexpage() {
            // console.log('下一页')
            if (this.currentPage < this.totalPages) {
                this.$emit('update:currentPage', this.currentPage + 1)
                if (this.$route.name !== 'My') {
                    window.scrollTo(0, 0)
                }
            }
        }
    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
nav {
    margin-top: 30px;
    display: flex;
    justify-content: flex-end;
    ul {
        cursor: pointer;
        display: flex;
        border-radius: 6px;
        overflow: hidden;

        li {
            font-size: 16px;
            color: white;
            padding: 14px 16px;
            background-color: #d6dbdf;
            border-right: 2px solid #e4e7ea;
            box-sizing: border-box;
            display: flex;
            align-items: center;

            &:last-child {
                border-right: none;
            }
        }
    }

    .totalRow {
        margin-right: 4px;
    }

    .active {
        // background-color: orange;
        background-color: #409EFF;
        color: white;
    }

}
</style>